<template>
  <div class="b2c-order">
    <b-card no-body>
      <div class="m-2">
        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="12">
            <h4>
              Danh sách đơn đổi Sim/eSIM
              <a
                  v-b-tooltip.hover.top="'Lấy lại danh sách!'"
                  class="btn-icon"
                  @click="$router.go()"
              >
                <feather-icon icon="RepeatIcon"
                />
              </a>
              <span class="float-right d-flex">
                <b-button
                    class="text-nowrap mr-2"
                    size="sm"
                    variant="primary"
                    @click="$bvModal.show('popupCreateChangeSimOrder')"
                >
                  Tạo đơn đổi sim
                </b-button>
                <b-button
                    class="text-nowrap mr-2"
                    size="sm"
                    variant="primary"
                    @click="$bvModal.show('popupCreateChangeESimOrder')"
                >
                  Tạo đơn đổi eSim
                </b-button>
                <b-input-group>
                  <b-form-input
                      v-model="searchString"
                      placeholder="Tìm kiếm nhanh"
                      size="sm"
                      @keypress.enter="quickSearch"
                  />
                  <b-input-group-append is-text role="button" @click="quickSearch">
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-append>
                </b-input-group>
              </span>
            </h4>
          </b-col>
          <b-col cols="12">
            <b-tabs>
              <b-tab active title="Tất cả đơn hàng" @click="changeTab(null)"></b-tab>
              <b-tab title="Chờ xác nhận" @click="changeTab(1)"></b-tab>
              <b-tab title="Đã xác nhận" @click="changeTab(2)"></b-tab>
              <b-tab title="Hoàn tất" @click="changeTab(3)"></b-tab>
              <b-tab title="Đơn hàng lỗi" @click="changeTab(90)"></b-tab>
              <b-tab title="Trả hàng" @click="changeTab(91)"></b-tab>
            </b-tabs>
          </b-col>
          <!-- Per Page -->
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table
                :columns="fields"
                :isLoading.sync="isLoading"
                :line-numbers="true"
                :pagination-options="{
                perPage: serverParams.pageSize,
                enabled: true,
                perPageDropdown: [20, 50, 100],
                dropdownAllowAll: false,
              }"
                :rows="rows"
                :totalRows="totalRecords"
                mode="remote"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'action'">
                  <b-dropdown
                      no-caret
                      size="sm"
                      toggle-class="text-decoration-none"
                      variant="link"
                  >
                    <template v-slot:button-content>
                      <feather-icon
                          class="text-body align-middle mr-25"
                          icon="MoreVerticalIcon"
                          size="16"
                      />
                    </template>
                    <b-dropdown-item @click="view(props.index)">
                      <feather-icon class="mr-50" icon="EyeIcon"/><span
                    >Xem chi tiết</span
                    >
                    </b-dropdown-item>
                    <b-dropdown-item @click="viewChangetstaus(props.index)">
                      <feather-icon class="mr-50" icon="Edit3Icon"/><span
                    >Chuyển trạng thái</span
                    >
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-else-if="props.column.field === 'DeliveryType'">
                  <feather-icon
                      v-if="props.row.ShipmentType == 'home'"
                      icon="CheckIcon"
                  />
                </span>
                <span v-else-if="props.column.field === 'IsUseESIM'">
                  <feather-icon v-if="props.row.IsUseESIM" icon="CheckIcon"/>
                </span>
                <span v-else-if="props.column.field === 'ShipmentCode'">
                   <a
                       :href="'https://i.ghtk.vn/' + props.row.ShipmentCode"
                       target="_blank"
                   >{{ props.row.ShipmentCode }}</a>
                </span>
                <span v-else-if="props.column.field === 'TotalPrice'">
                  {{ props.formattedRow[props.column.field] | number }}
                </span>
                <span v-else-if="props.column.field === 'RecentPhones'">
                  <span v-html="props.row.RecentPhones"/>
                </span>
                <span v-else-if="props.column.field === 'StatusId'">
                  <span class="badge badge-light-info">{{
                      statusList.find((m) => m.id == props.row.StatusId).text
                    }}</span>
                </span>
                <span v-else-if="props.column.field === 'PaymentChannel'">
                  <span v-html="props.row.PaymentChannel"/>
                </span>
                <span v-else-if="props.column.field === 'OrderCode'">
                  <a class="text-primary" @click="view(props.index)">{{
                      props.row.OrderCode
                    }}</a>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
        id="modal-change-status"
        :title="'Thay đổi trạng thái đơn ' + currentItem.Id"
        @ok="handleChangeStatus"
    >
      <validation-observer ref="modalView">
        <b-row>
          <b-col cols="12">
            <b-form-group label="Trạng thái mới">
              <Select2
                  v-model="currentItem.newStatus"
                  :options="statusList.filter((i) => i.id != 90)"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Ghi chú">
              <b-form-textarea v-model="currentItem.notes"/>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-input-seri"
        :title="'Nhập số seri Sim mới'"
        hide-footer
        size="sm"
        @hide="onModalSeriHide()"
    >
      <template>
        <validation-observer ref="modalInputSeri">
          <b-col cols="12">
            <b-form-group label="Nhập 20 số seri">
              <b-form-input v-model="currentItem.SeriNo" size="sm" type="number"/>
            </b-form-group>
          </b-col>
          <b-col v-if="currentItem.IsUseESIM" cols="12">
            <b-form-group label="Mã QR">
              <b-form-radio-group
                  id="btn-radios-2"
                  v-model="qrType"
                  :options="oprionsQRFile"
                  button-variant="outline-primary"
                  buttons
                  name="radio-btn-outline"
                  size="sm"
              ></b-form-radio-group>
            </b-form-group>
            <input
                v-if="qrType == 1"
                accept="image/"
                type="file"
                @change="onUploadFileQR($event)"
            />
            <div v-if="qrType == 2" class="pb-1">
              Code: {{ currentItem.qrcode || "" }}
            </div>
            <qrcode-stream
                v-if="qrType == 2"
                :track="paintCenterText"
                @decode="onDecode"
            ></qrcode-stream>
          </b-col>
        </validation-observer>
      </template>
      <template scope-slot="modal-footer">
        <div class="group-button-footer pt-1">
          <button class="btn btn-secondary" type="button" @click="hideModalInputSeri">
            Cancel
          </button>
          <button class="btn btn-primary" type="button" @click="handleOk">OK</button>
        </div>
      </template>
    </b-modal>
    <b-modal
        id="modal-view"
        :title="`Thông tin đơn hàng [${currentItem.OrderCode}]`"
        hide-footer
        ok-title="Đổi SIM"
        size="xl"
        @hide="handleHide"
    >
      <b-card class="modal-view-body" no-body>
        <div class="m-2">
          <validation-observer ref="changeSIMInfo" class="row">
            <b-col cols="12"
            ><h3>
              Thông tin cần đổi cấp lại {{ currentItem.IsUseESIM ? "ESIM" : "USIM" }}
            </h3></b-col
            >
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group>
                  <label> Số TB cần đổi sim <span class="text-primary">*</span> </label>
                  <b-form-input v-model="currentItem.Phone" size="sm"/>
                  <div class="error-txt">
                    <small v-if="errors.length > 0"
                    >Số TB cần đổi sim không được để trống</small
                    >
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label> Sử dụng esim </label>
                <b-form-checkbox v-model="currentItem.IsUseESIM"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group>
                  <label> Loại thuê bao <span class="text-primary">*</span> </label>
                  <search-select
                      v-model="currentItem.SubscriptionType"
                      :options="subscriberTypeOptions"
                  ></search-select>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Loại thuê bao không hợp lệ</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label>
                    Tải bản cam kết <span class="text-primary">*</span>
                    <br/>
                    <span>(Có đầy đủ chữ ký KH)</span>
                  </label>
                  <div>
                    <label class="label-pledge-container" style="cursor: pointer">
                      <template v-if="!currentItem.CommitmentImage || currentItem.CommitmentImage.length == 0">
                        <img
                            :src="
                            currentItem.CommitmentImage
                              ? 'https://my1.itel.vn/UploadTemp/' +
                                currentItem.CommitmentImage
                              : ImgPledgeDemo
                          "
                            alt="img"
                            height="100"
                            width="100"
                        />
                      </template>
                      <template v-if="currentItem.CommitmentImage && currentItem.CommitmentImage.length > 0">
                        <div class="image-container-list">
                          <template v-for="(item, index) in currentItem.CommitmentImage">
                            <div :key="index" class="image-container">
                              <img
                                  :src="'https://my1.itel.vn/UploadTemp/' + item"
                                  alt="img"
                                  height="100"
                                  width="100"
                              />
                              <button
                                  class="btn-preview-image-container"
                              >
                                <img
                                    alt=""
                                    src="@/assets/images/preview.png"
                                    @click="onPreviewPledgeImage(index)"
                                />
                              </button>
                            </div>
                          </template>
                        </div>
                      </template>
                    </label>
                  </div>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Bản cam kết không hợp lệ</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group label="Giới tính">
                  <search-select
                      v-model="currentItem.Gender"
                      :options="optionGenders"
                  ></search-select>
                  <small
                      v-if="
                      checkInfo.subInfo && checkInfo.subInfo.GENDER != getGenderCode()
                    "
                      class="text-primary"
                  >{{ checkInfo.subInfo.GENDER }}</small
                  >
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Giới tính không được để trống</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label> Ảnh chuyển khoản <span class="text-primary">*</span> </label>
                  <div>
                    <label class="label-pledge-container image-container" style="cursor: pointer">
                      <img
                          :src="
                          currentItem.PaymentImage
                            ? 'https://my1.itel.vn/UploadTemp/' + currentItem.PaymentImage
                            : ImgPledgeDemo
                        "
                          alt="img"
                          height="100"
                          width="100"
                      />
                      <input
                          accept="image/png, image/jpeg"
                          hidden
                          type="file"
                          @change="onLoadPledge"
                      />
                      <button
                          v-if="currentItem.PaymentImage"
                          class="btn-preview-image-container"
                      >
                        <img
                            alt=""
                            src="@/assets/images/preview.png"
                            @click="onPreviewPaymentImage()"
                        />
                      </button>
                    </label>
                  </div>
                  <div class="error-txt">
                    <small v-if="errors.length > 0">Ảnh chuyển khoản không hợp lệ</small>
                  </div>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Phí cấp đổi">
                <b-form-input :value="formatPrice(currentItem.ExchangePrice)" disabled size="sm"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Tổng phí">
                <b-form-input :value="formatPrice(currentItem.ExchangePrice + currentItem.ShippingFee)" disabled
                              size="sm"/>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Phí vận chuyển">
                <b-form-input :value="formatPrice(currentItem.ShippingFee)" disabled size="sm"/>
              </b-form-group>
            </b-col>
            <b-col v-if="!(currentItem.CreateFrom === 'crm.itel.vn')" cols="6">
              <b-form-group label="Dòng máy">
                <b-form-input v-model="currentItem.EsimDevice" disabled size="sm"/>
              </b-form-group>
            </b-col>
          </validation-observer>
        </div>
      </b-card>
      <b-row class="modal-view-body">
        <b-col cols="9">
          <b-card no-body>
            <div class="m-2">
              <validation-observer ref="modalChangeSIM" class="row">
                <b-col cols="12"
                ><h3>
                  Thông tin khách hàng cần đổi
                  {{ currentItem.IsUseESIM ? "ESIM" : "USIM" }}
                </h3></b-col
                >
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="Họ và tên">
                      <b-form-input v-model="currentItem.FullName" size="sm"/>
                      <small
                          v-if="
                          !compareStringLowerCase(
                            checkInfo.subInfo,
                            'FULLNAME',
                            currentItem,
                            'FullName'
                          )
                        "
                          class="text-primary"
                      >{{ checkInfo.subInfo.FULLNAME }}</small
                      >
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Họ và tên không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="Số giấy tờ">
                      <b-form-input v-model="currentItem.IdCardCode" size="sm"/>
                      <small
                          v-if="
                          checkInfo.subInfo &&
                          checkInfo.subInfo.IDNUMBER != currentItem.IdCardCode
                        "
                          class="text-primary"
                      >{{ checkInfo.subInfo.IDNUMBER }}</small
                      >
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Số CMND/CC/HC không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="Ngày sinh">
                      <b-form-datepicker
                          v-model="currentItem.Dob"
                          :date-format-options="{
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                        }"
                          locale="vi-VN"
                          size="sm"
                      ></b-form-datepicker>
                      <small
                          v-if="
                          checkInfo.subInfo &&
                          checkInfo.subInfo.BIRTHDAY != formatDate(currentItem.Dob)
                        "
                          class="text-primary"
                      >{{ checkInfo.subInfo.BIRTHDAY }}</small
                      >
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Ngày sinh không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="Ngày cấp">
                      <b-form-datepicker
                          v-model="currentItem.IdCardCreatedDate"
                          :date-format-options="{
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                        }"
                          locale="vi-VN"
                          size="sm"
                      ></b-form-datepicker>
                      <small
                          v-if="
                          checkInfo.subInfo &&
                          checkInfo.subInfo.PLACEDATE !=
                            formatDate(currentItem.IdCardCreatedDate)
                        "
                          class="text-primary"
                      >{{ checkInfo.subInfo.PLACEDATE }}</small
                      >
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Ngày cấp CMND/CC/HC không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="Địa chỉ">
                      <b-form-input v-model="currentItem.Address" size="sm"/>
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Địa chỉ không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="Nơi cấp">
                      <b-form-input v-model="currentItem.IdCardPlace" size="sm"/>
                      <small
                          v-if="
                          !compareStringLowerCase(
                            checkInfo.subInfo,
                            'PLACEOFISSUE',
                            currentItem,
                            'IdCardPlace'
                          )
                        "
                          class="text-primary"
                      >{{ checkInfo.subInfo.PLACEOFISSUE }}</small
                      >
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Nơi cấp CMND/CC/HC không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>

                <!-- <b-col cols="2">
                  <b-form-group label="Số iTel">
                    <b-form-input size="sm" v-model="currentItem.Phone" disabled />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="Loại xác thực">
                    <b-form-input size="sm" v-model="currentItem.ValidateType" disabled />
                  </b-form-group>
                </b-col>
                <b-col cols="2">
                  <b-form-group label="ESIM?">
                    <feather-icon icon="CheckSquareIcon" size="20" v-if="currentItem.IsUseESIM" />
                    <feather-icon icon="SquareIcon" size="20" v-else />
                  </b-form-group>
                </b-col> -->
                <b-col v-if="currentItem.RecentSimSerial" cols="6">
                  <b-form-group class="m-0" label="Số serial cũ">
                    <span
                        :class="`badge ${
                        !checkInfo.SimSerialCheck
                          ? 'badge-light-primary'
                          : 'badge-light-success'
                      } mr-2`"
                    >{{ currentItem.RecentSimSerial }}</span
                    >
                    <div :class="!checkInfo.SimSerialCheck ? 'error-txt' : 'valid-txt'">
                      <small
                      >Số serial cũ {{ !checkInfo.SimSerialCheck ? "không" : "" }} chính
                        xác!</small
                      >
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                      v-if="currentItem.LastRecharge"
                      class="m-0"
                      label="Mệnh giá thẻ nạp"
                  >
                    <span
                        :class="`badge ${
                        !checkInfo.LastRechargeCheck
                          ? 'badge-light-primary'
                          : 'badge-light-success'
                      } mr-2`"
                    >{{
                        cardsOptions.find((el) => el.id === currentItem.LastRecharge).text
                      }}</span
                    >
                    <div
                        :class="!checkInfo.LastRechargeCheck ? 'error-txt' : 'valid-txt'"
                    >
                      <small
                      >Mệnh giá thẻ nạp
                        {{ !checkInfo.LastRechargeCheck ? "không" : "" }} chính
                        xác!</small
                      >
                    </div>
                  </b-form-group>
                </b-col>
                <b-col
                    v-if="currentItem.RecentPhones && currentItem.RecentPhones.length > 0"
                    class="mt-1"
                    cols="12"
                >
                  <b-form-group
                      v-if="
                      currentItem.RecentPhones &&
                      currentItem.RecentPhones.replace(/\[|\]/g, '')
                        .split(',')
                        .filter((i) => i.trim && i.trim() != '').length > 0
                    "
                      class="m-0"
                      label="Số liên hệ gần đây"
                  >
                    <span
                        v-for="i in currentItem.RecentPhones.replace(/\[|\]/g, '').split(
                        ','
                      )"
                        :key="i"
                        class="badge badge-light-primary mr-2"
                    >{{ i }}</span
                    >
                    <p class="pt-1">
                      Kiểm tra có
                      <span class="badge badge-primary"
                      ><b>{{ checkInfo.RecentPhonesCheck }}</b></span
                      >
                      số chính xác!
                    </p>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="Ghi chú">
                    <b-form-textarea
                        v-model="currentItem.notes"
                        :class="{
                        isValid:
                          !currentItem.notes ||
                          (currentItem.notes && !!!currentItem.notes.trim()),
                      }"
                        max-rows="6"
                        placeholder="Ghi chú..."
                        rows="3"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </validation-observer>
            </div>
          </b-card>
          <b-card no-body>
            <div class="m-2">
              <validation-observer ref="modalReceiveInfo" class="row">
                <b-col cols="12"><h3>Thông tin nhận hàng</h3></b-col>
                <b-col v-if="!currentItem.IsUseESIM" cols="12">
                  <validation-provider #default="{ errors }" rules="">
                    <b-form-group label="Đối tác giao hàng">
                      <b-form-input v-model="currentItem.ShippingPartner" disabled size="sm"/>
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Đối tác giao hàng không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required">
                    <b-form-group label="Họ và tên">
                      <b-form-input v-model="currentItemInfo.fullName" size="sm"/>
                      <div class="error-txt">
                        <small v-if="errors.length > 0"
                        >Họ và tên không được để trống</small
                        >
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col cols="6">
                  <validation-provider #default="{ errors }" rules="required|num">
                    <b-form-group label="SDT liên hệ">
                      <b-form-input
                          v-model="currentItemInfo.ContactPhone"
                          size="sm"
                          type="number"
                      />
                      <div class="error-txt">
                        <small v-if="errors.length > 0">Số điện thoại không hợp lệ</small>
                      </div>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col v-if="!currentItem.IsUseESIM" cols="12">
                  <b-row>
                    <b-col cols="4">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-group label="Hình thức nhận hàng">
                          <search-select
                              v-model="currentItemInfo.shipment_type"
                              :options="optionsShipmentType"
                          ></search-select>
                          <div class="error-txt">
                            <small v-if="errors.length > 0"
                            >Hình thức nhận hàng không được để trống</small
                            >
                          </div>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </b-col>
              </validation-observer>
              <template
                  v-if="currentItemInfo.shipment_type == 'home' && !currentItem.IsUseESIM"
              >
                <validation-observer ref="shipmentTypeHome" class="row">
                  <b-col cols="12">
                    <validation-provider
                        #default="{ errors }"
                        :rules="!currentItem.IsUseESIM ? 'required' : ''"
                    >
                      <b-form-group label="Địa chỉ">
                        <b-form-input v-model="currentItemInfo.addr" size="sm"/>
                        <div class="error-txt">
                          <small v-if="errors.length > 0"
                          >Địa chỉ không được để trống</small
                          >
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6">
                    <validation-provider
                        #default="{ errors }"
                        :rules="!currentItem.IsUseESIM ? 'required|addressId' : ''"
                    >
                      <b-form-group label="Tỉnh/Thành phố">
                        <search-select
                            v-model="currentItemInfo.CityId"
                            :options="Cities"
                            @change="fetchDistricts(true)"
                        ></search-select>
                        <div class="error-txt">
                          <small v-if="errors.length > 0"
                          >Tỉnh/Thành phố không được để trống</small
                          >
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6">
                    <validation-provider
                        #default="{ errors }"
                        :rules="!currentItem.IsUseESIM ? 'required|addressId' : ''"
                    >
                      <b-form-group label="Quận/Huyện">
                        <search-select
                            v-model="currentItemInfo.DistrictId"
                            :options="Districts"
                            @change="fetchWards(true)"
                        ></search-select>
                        <div class="error-txt">
                          <small v-if="errors.length > 0"
                          >Quận/Huyện không được để trống</small
                          >
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6">
                    <validation-provider
                        #default="{ errors }"
                        :rules="!currentItem.IsUseESIM ? 'required|addressId' : ''"
                    >
                      <b-form-group label="Phường/Xã/Thị trấn">
                        <search-select
                            v-model="currentItemInfo.WardId"
                            :options="Wards"
                            @change="fetchHamlets(true)"
                        ></search-select>
                        <div class="error-txt">
                          <small v-if="errors.length > 0"
                          >Phường/Xã/Thị trấn không được để trống</small
                          >
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6">
                    <validation-provider #default="{ errors }" rules="">
                      <b-form-group>
                        <label> Ấp/Khu </label>
                        <search-select
                            v-model="currentItemInfo.HamletId"
                            :options="Hamlets"
                        ></search-select>
                        <div class="error-txt">
                          <small v-if="errors.length > 0"
                          >Ấp/Khu không được để trống</small
                          >
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </validation-observer>
              </template>
              <template
                  v-if="currentItemInfo.shipment_type == 'itel' && !currentItem.IsUseESIM"
              >
                <validation-observer ref="shipmentTypeItel" class="row">
                  <b-col cols="12">
                    <validation-provider
                        #default="{ errors }"
                        :rules="!currentItem.IsUseESIM ? 'required|addressId' : ''"
                    >
                      <b-form-group label="Chọn chi nhánh">
                        <!-- <b-form-select size="sm" v-model="currentItemInfo.StoreId" :options="Stores"></b-form-select> -->
                        <search-select
                            v-model="currentItemInfo.StoreId"
                            :options="Stores"
                        ></search-select>
                        <div class="error-txt">
                          <small v-if="errors.length > 0"
                          >Chi nhánh không được để trống</small
                          >
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </validation-observer>
              </template>
              <template v-if="currentItem.IsUseESIM">
                <validation-observer ref="shipmentEsim" class="row">
                  <b-col cols="12">
                    <validation-provider
                        #default="{ errors }"
                        :rules="currentItem.IsUseESIM ? 'required' : ''"
                    >
                      <b-form-group label="Email">
                        <b-form-input v-model="currentItem.ContactEmail" size="sm"/>
                        <div class="error-txt">
                          <small v-if="errors.length > 0"
                          >Email không được để trống</small
                          >
                        </div>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </validation-observer>
              </template>
            </div>
          </b-card>
        </b-col>
        <b-col cols="3">
          <b-card no-body>
            <div class="m-2">
              <b-row>
                <b-col cols="12">
                  <b-form-group v-slot="{ ariaDescribedby }" label="Loại giấy tờ">
                    <b-form-radio-group
                        id="radio-group-1"
                        v-model="currentItem.ValidateType"
                        :aria-describedby="ariaDescribedby"
                        :options="optionsDoctype"
                        name="radio-options"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="Mặt trước ảnh CMND/CC/HC">
                    <img
                        :src="
                        'https://my1.itel.vn/UploadTemp/' + currentItem.IdCardFrontImage
                      "
                        class="img-responsive avatar-view"
                        style="margin: 10px 0px 10px 5px"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group label="Mặt sau ảnh CMND/CC/HC">
                    <img
                        :src="
                        'https://my1.itel.vn/UploadTemp/' + currentItem.IdCardBackImage
                      "
                        class="img-responsive avatar-view"
                        style="margin: 10px 0px 10px 5px"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group v-if="currentItem.FaceImage" label="Ảnh chân dung">
                    <img
                        :src="'https://my1.itel.vn/UploadTemp/' + currentItem.FaceImage"
                        class="img-responsive avatar-view"
                        style="margin: 10px 0px 10px 5px"
                    />
                  </b-form-group>
                  <div v-else style="height: 100%">
                    <label class="bv-no-focus-ring col-form-label pt-0"
                    >Ảnh chân dung</label
                    >
                    <div
                        style="
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        fontsize: 1.5rem;
                      "
                    >
                      NO IMAGE
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="logs && logs.length > 0" class="modal-view-body">
        <b-col cols="12">
          <h5>Logs</h5>
          <b-card body-class="p-0" class="p-0">
            <b-card-text style="overflow: auto">
              <table class="table table-bordered table-sm">
                <tr>
                  <th>Loại</th>
                  <th>UserID</th>
                  <th>Ngày</th>
                </tr>
                <tr v-for="i in logs" :key="i.Id">
                  <td>{{ i.LogType }}</td>
                  <td>{{ i.UserID }}</td>
                  <td>{{ i.LogDate }}</td>
                </tr>
              </table>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>

      <template scope-slot="modal-footer">
        <div class="group-button-footer">
          <button
              class="btn btn-secondary"
              type="button"
              @click="$bvModal.hide('modal-view')"
          >
            Cancel
          </button>
          <button class="btn btn-primary" type="button" @click="onUpdate">
            Cập nhật
          </button>
          <button class="btn btn-primary" type="button" @click="showModalInputSeri">
            Đổi SIM
          </button>
          <button class="btn btn-primary" type="button" @click="createShipOrder(currentItem.Id)">
            Tạo vận đơn
          </button>
        </div>
      </template>
    </b-modal>
    <PopupCreateOrder
        :modalSrc="`${ctx.URL_FRONTEND}/ho-tro/doi-cap-sim`"
        modalId="popupCreateChangeSimOrder"
        modalTitle="Tạo đơn đổi sim"
        @onCreateOrderSuccess="loadItems()"
    />
    <PopupCreateOrder
        :modalSrc="`${ctx.URL_FRONTEND}/ho-tro/doi-cap-esim`"
        modalId="popupCreateChangeESimOrder"
        modalTitle="Tạo đơn đổi eSim"
        @onCreateOrderSuccess="loadItems()"
    />
  </div>
</template>

<script>
//${ctx.URL_FRONTEND}/ho-tro/doi-cap-sim
//https://localhost:8000/ho-tro/thong-tin-nhan-sim?pn=0879851515&type=sim&txnRef=
//https://localhost:8000/ho-tro/thong-tin-nhan-sim?pn=0879999515&type=esim&txnRef=SIM-230410963923
//"https://localhost:8000/ho-tro/doi-cap-sim"
//modalSrc="https://localhost:8000/ho-tro/doi-cap-esim"
import ImgPledgeDemo from "@/assets/images/picture.png";
import {$ctx} from "@themeConfig";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "@validations";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import SearchSelect from "../components/select/SearchSelect.vue";
import PopupCreateOrder from "./PopupCreateOrder.vue";
import axios from "axios";

extend("num", (value) => {
  return !/\D/.test(value);
});

extend("addressId", (value) => {
  return !!value;
});

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BCardText,
    BFormTextarea,
    BInputGroup,
    BInputGroupAppend,
    SearchSelect,
    BFormRadioGroup,
    PopupCreateOrder,
    BFormRadio,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  mounted() {
    this.loadMasterData();
    window.addEventListener("message", this.handleMessageEventer, false);
  },

  beforeDestroy() {
    window.removeEventListener("message", this.handleMessageEventer);
  },
  watch: {
    $route(to, from) {
      this.loadMasterData();
    },
    currentItem: {
      handler(val) {
        if (!this.modalInputSeriOpen) {
          if (this.firstTimeOpenModal.currentCheck) {
            this.requiredUpdate = false;
            this.firstTimeOpenModal.currentCheck = false;
          } else {
            this.requiredUpdate = true;
          }
        }
      },
      deep: true,
    },
    currentItemInfo: {
      handler(val) {
        if (!this.modalInputSeriOpen) {
          if (this.firstTimeOpenModal.currentInfoCheck) {
            this.requiredUpdate = false;
            this.firstTimeOpenModal.currentInfoCheck = false;
          } else {
            this.requiredUpdate = true;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    getShipmentFee() {
      axios.get(this.URL_WEB_API + '/api/web/' +
          "ghtk/fee?province=" +
          this.currentItemInfo.CityId +
          "&district=" +
          this.currentItemInfo.DistrictId +
          "&ward=" +
          this.currentItemInfo.WardId
      )
          .then((response) => {
            this.currentItem.ShippingFee = response.data.result.fee.fee
          })
          .catch((err) => {
            this.$toast("Lỗi lấy phí vận chuyển", {
              icon: true,
              closeButton: "button",
            });
          });
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async onLoadPledge(e) {
      if (e?.target?.files && e?.target?.files.length > 0) {
        this.loading(true);
        let bodyData = []
        for (let i = 0; i < e?.target?.files.length; i++) {
          const obj = e?.target?.files[i]
          let imgBase64 = await this.toBase64(obj)

          bodyData.push({
            data: imgBase64.replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
          })
        }
        useJwt
            .postEx(this.URL_WEB_API + "/api/web/ekyc/upload-sim-img", bodyData)
            .then((response) => {
              this.currentItem.PaymentImage = response.data.result[0].file[0]
              this.loading(false);
            });
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    onPreviewPledgeImage(index) {
      const preview = this.$imagePreview({
        initIndex: index,
        maskBackgroundColor: 'rgba(255,255,255, 1)',
        images: this.currentItem.CommitmentImage ? this.currentItem.CommitmentImage.map(el => `https://my1.itel.vn/UploadTemp/${el}`) : [],
        onClose: () => {
        },
      });
    },
    onPreviewPaymentImage() {
      const preview = this.$imagePreview({
        initIndex: 0,
        maskBackgroundColor: 'rgba(255,255,255, 1)',
        images: [
          this.currentItem.PaymentImage
              ? "https://my1.itel.vn/UploadTemp/" + this.currentItem.PaymentImage
              : "",
        ],
        onClose: () => {
        },
      });
    },
    handleMessageEventer(e) {
      let key = e.message ? "message" : "data";
      let data = e[key];

      if (typeof data == "object") {
        if (data?.type == "onChangeSIMStep2") {
          useJwt
              .post("doi-sim/add-order-step2", data.data)
              .then((response) => {
                if (response.status == 200) {
                  this.$toast.success("Xác nhận thành công!", {
                    icon: true,
                    closeButton: "button",
                  });
                } else {
                  this.$toast.error(
                      "Có lỗi trong khi thực hiện thanh toán, Quý khách vui lòng thử lại!",
                      {icon: true, closeButton: "button"}
                  );
                }

                this.loadItems();

                this.$bvModal.hide("popupCreateChangeSimOrder");
                this.$bvModal.hide("popupCreateChangeESimOrder");
              })
              .catch((err) => {
                this.$toast.error(
                    "Có lỗi trong khi thực hiện thanh toán, Quý khách vui lòng thử lại!",
                    {icon: true, closeButton: "button"}
                );
                this.$bvModal.hide("popupCreateChangeSimOrder");
                this.$bvModal.hide("popupCreateChangeESimOrder");
              });
        } else if (data?.type == "onAddChangeSIMOrder") {
          this.loading(true);
          useJwt
              .post("doi-sim/add-order", data.data)
              .then((response) => {
                this.loading(false);
                this.$toast.info("Gửi yêu cầu thành công", {
                  icon: true,
                  closeButton: "button",
                });

                document
                    .getElementById(`iframepopupCreateChangeSimOrder`)
                    .contentWindow.postMessage(
                    {
                      type: "onAddChangeSIMOrderSuccess",
                      data: response.data.result,
                    },
                    "*"
                );
              })
              .catch((err) => {
                this.$toast.error(
                    err.response?.data?.message || "Có lỗi trong quá trình đổi sim!",
                    {icon: true, closeButton: "button"}
                );
                document
                    .getElementById(`iframepopupCreateChangeSimOrder`)
                    .contentWindow.postMessage(
                    {
                      type: "onAddChangeSIMOrderFail",
                      data: {},
                    },
                    "*"
                );
                this.loading(false);
              });
        } else if (data?.type == "onAddChangeESIMOrder") {
          this.loading(false);

          useJwt
              .post("doi-sim/add-order", data.data)
              .then((response) => {
                this.$toast.info("Gửi yêu cầu thành công", {
                  icon: true,
                  closeButton: "button",
                });
                document
                    .getElementById(`iframepopupCreateChangeESimOrder`)
                    .contentWindow.postMessage(
                    {
                      type: "onAddChangeESIMOrderSuccess",
                      data: response.data.result,
                    },
                    "*"
                );
              })
              .catch((err) => {
                this.$toast.error(
                    err.response?.data?.message || "Có lỗi trong quá trình đổi esim!",
                    {icon: true, closeButton: "button"}
                );
                document
                    .getElementById(`iframepopupCreateChangeESimOrder`)
                    .contentWindow.postMessage(
                    {
                      type: "onAddChangeESIMOrderFail",
                      data: {},
                    },
                    "*"
                );
                this.loading(false);
              });
        }
      }
    },
    /*viewDKTTHist(p){
      console.log(p);
      this.dkttRows = p.reg_hist;
      this.$bvModal.show('modal-dktt');
    },*/
    onModalSeriHide() {
      this.modalInputSeriOpen = false;
    },
    dateFormat(v) {
      return moment(v, "YYYYMMDDHHmmss").format("DD/MM/YYYY hh:mm:ss");
    },
    formatDate(v) {
      return moment(v, "YYYY/MM/DD").format("DD/MM/YYYY");
    },
    formatDatePicker(v) {
      return moment(v, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
    changeTab(i) {
      this.serverParams.columnFilters.searchString = null;
      this.serverParams.columnFilters.StatusId = i;
      this.loadItems();
    },
    quickSearch() {
      this.serverParams.columnFilters.StatusId = null;
      this.serverParams.columnFilters.searchString = this.searchString;
      this.loadItems();
    },
    loadMasterData() {
      this.loadItems();
      this.fetchCities();
      this.fetchStores();
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.loadItems();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.loadItems();
    },
    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },
    loadItems() {
      this.loading(true);
      this.isLoading = true;
      useJwt
          .post("doi-sim/order-list", this.serverParams)
          .then((response) => {
            this.rows = response.data.result;
            //console.log(this.rows)
            this.totalRecords = response.data.totalRecords;
            this.isLoading = false;
            this.loading(false);
          })
          .catch((error) => {
            this.loading(false);
            this.isLoading = false;
          });
    },
    viewChangetstaus(idx) {
      this.currentItem.newStatus = this.currentItem.Status;
      this.isLoading = true;
      this.currentItem = this.rows[idx];
      this.$bvModal.show("modal-change-status");
      this.isLoading = false;
    },
    handleChangeStatus(bvModalEvt) {
      bvModalEvt.preventDefault();
      useJwt
          .put("doi-sim/" + this.currentItem.Id + "/" + this.currentItem.newStatus, {
            notes: this.currentItem.notes,
          })
          .then((response) => {
            this.loadItems();
            this.loading(false);
            this.$bvModal.hide("modal-change-status");
          })
          .catch((error) => {
            if (error.response.data.code == 403) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Không có quyền thao tác nghiệp vụ này!",
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.response.data.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            }
            this.loading(false);
          });
    },
    view(idx) {
      this.isLoading = true;
      this.firstTimeOpenModal = {
        currentCheck: true,
        currentInfoCheck: true,
      };
      this.currentItem = this.rows[idx];
      this.currentItem.notes = this.rows[idx].Note;
      this.currentItem.Dob = this.formatDatePicker(this.currentItem.Dob);
      this.currentItem.IdCardCreatedDate = this.formatDatePicker(
          this.currentItem.IdCardCreatedDate
      );
      this.currentItemInfo = JSON.parse(this.currentItem.Info);
      if (!this.currentItemInfo) {
        this.currentItemInfo = {
          CityId: 0,
          ContactPhone: "",
          DistrictId: 0,
          HamletId: 0,
          StoreId: 0,
          WardId: 0,
          addr: "",
          agree: true,
          fullName: "",
          shipment_type: "home",
        };
      }
      this.fetchDistricts(false, false);
      this.fetchWards(false, false);
      this.fetchHamlets(false, false);
      this.loading(true);
      // console.log(
      //   "this.currentItem.RecentPhones",
      //   this.currentItem.RecentPhones.replace(/\[|\]/g, "")
      //     .split(",")
      //     .filter((i) => i.trim && i.trim() != "").length,
      //   this.currentItem
      // );
      useJwt
          .post("doi-sim/check", {
            Phone: this.currentItem.Phone,
            RecentPhones: this.currentItem.RecentPhones.replace(/\[|\]/g, "").split(","),
            RecentSimSerial: this.currentItem.RecentSimSerial,
            LastRecharge: this.currentItem.LastRecharge,
          })
          .then((response) => {
            this.checkInfo = response.data.result;
            useJwt
                .get("doi-sim/order-detail/" + this.currentItem.Id)
                .then((response) => {
                  this.logs = response.data.extra.Log || [];
                  this.loading(false);
                  this.$bvModal.show("modal-view");
                  this.isLoading = false;
                })
                .catch((error) => {
                  this.loading(false);
                  this.isLoading = false;
                  this.logs = [];
                });
          })
          .catch((error) => {
            this.loading(false);
            this.isLoading = false;
          });
    },
    createShipOrder(orderId) {
      this.loading(true)
      useJwt.get('doi-sim/shipOrder/' + orderId).then(res => {
        this.loading(false);
        if (res.data.code === 200) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Tạo vận đơn thành công!",
              icon: "AlertTriangleIcon",
              variant: "success",
            },
          });
        }
        if (res.data.code === 404) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message,
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
        if (res.data.code === 500) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Tạo vận đơn thất bại!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
        }
      }).catch(err => {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Tạo vận đơn thất bại!, vui lòng thử lại",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      })
    },
    showModalInputSeri() {
      if (this.requiredUpdate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng ấn cập nhật trước khi thao tác đổi sim!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (
          (this.checkInfo.RecentPhonesCheck != undefined && this.checkInfo.RecentPhonesCheck < 3)
          && !this.checkInfo.SimSerialCheck
          && !this.checkInfo.LastRechargeCheck
      ) {
        if (this.currentItem.RecentPhones
            && this.currentItem.RecentPhones.replace(/\[|\]/g, '').split(',').filter((i) => i.trim && i.trim() != '').length > 0
            && this.checkInfo.RecentPhonesCheck != undefined
            && this.checkInfo.RecentPhonesCheck < 3
        ) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "3 số liên hệ gần nhất không chính xác, không thể tiếp tục!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return
        }
        if (this.currentItem.RecentSimSerial && !this.checkInfo.SimSerialCheck) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Số seri cũ không chính xác, không thể tiếp tục!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return
        }
        if (this.currentItem.LastRecharge && !this.checkInfo.LastRechargeCheck) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Mệnh giá thẻ nạp không chính xác, không thể tiếp tục!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });

        }
      } else {
        this.$bvModal.show("modal-input-seri");
        this.modalInputSeriOpen = true;
      }
    },
    hideModalInputSeri() {
      this.$bvModal.hide("modal-input-seri");
      this.modalInputSeriOpen = false;
    },
    handleOk(bvModalEvt) {
      if (!this.currentItem.SeriNo) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn chưa nhập số seri!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      const data = {
        id: this.currentItem.Id,
        isesim: this.currentItem.IsUseESIM,
        birthday: this.formatDate(this.currentItem.Dob),
        fullname: this.currentItem.FullName,
        ghichu: this.currentItem.notes ? this.currentItem.notes : "",
        idnumber: this.currentItem.IdCardCode,
        msisdn: this.currentItem.Phone,
        placedate: this.formatDate(this.currentItem.IdCardCreatedDate),
        seri: this.currentItem.SeriNo ? this.currentItem.SeriNo : "",
        qrcode: this.currentItem.qrcode || null,
        qrimage: this.currentItem.qrimage
            ? this.currentItem.qrimage
                .replace("data:image/jpeg;base64,", "")
                .replace("data:image/png;base64,", "")
                .replace("data:image/jpg;base64,", "")
            : null,
      };

      useJwt
          .post("doi-sim/change-isim", data)
          .then((response) => {
            if (response.data.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Cập nhật thông tin đổi sim thành công",
                  icon: "AlertTriangleIcon",
                  variant: "success",
                },
              });
              this.hideModalInputSeri();
              this.$bvModal.hide("modal-view");
            }
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.result ? err.response?.data?.result : err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    onDecode(decodedString) {
      this.currentItem = {
        ...this.currentItem,
        qrcode: decodedString,
      };
    },
    onUploadFileQR(e) {
      if (!e.target.files || !e.target.files[0]) return;
      const that = this;

      const FR = new FileReader();
      FR.addEventListener("load", function (evt) {
        that.currentItem.qrimage = evt.target.result;
      });
      FR.readAsDataURL(e.target.files[0]);
    },
    paintCenterText(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {boundingBox, rawValue} = detectedCode;

        const centerX = boundingBox.x + boundingBox.width / 2;
        const centerY = boundingBox.y + boundingBox.height / 2;

        const fontSize = Math.max(12, (50 * boundingBox.width) / ctx.canvas.width);

        ctx.font = `bold ${fontSize}px sans-serif`;
        ctx.textAlign = "center";

        ctx.lineWidth = 3;
        ctx.strokeStyle = "#35495e";
        ctx.strokeText(detectedCode.rawValue, centerX, centerY);

        ctx.fillStyle = "#5cb984";
        ctx.fillText(rawValue, centerX, centerY);
      }
    },
    handleHide() {
      this.$bvModal.hide("modal-view");
      this.loadItems();
      this.isEditPhoneEmail = false;
    },
    onSaveNote() {
      if (
          !this.currentItem.notes ||
          (this.currentItem.notes && !this.currentItem.notes.trim())
      )
        return;

      this.loading(true);
      this.isLoading = true;
      const data = {
        id: this.currentItem.Id,
        note: this.currentItem.notes.trim(),
      };

      useJwt
          .post("doi-sim/update-note", data)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Lưu ghi chú thành công",
                icon: "AlertTriangleIcon",
                variant: "info",
              },
            });
            this.loadItems();
            this.loading(false);
            this.isLoading = false;
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            this.loading(false);
            this.isLoading = false;
          });
    },
    async onUpdate() {
      var validate = await this.$refs.changeSIMInfo.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button",
        });
        return;
      }
      var validate = await this.$refs.modalChangeSIM.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button",
        });
        return;
      }
      var validate = await this.$refs.modalReceiveInfo.validate().then((success) => {
        return success;
      });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button",
        });
        return;
      }
      if (this.currentItem.IsUseESIM) {
        var validateHome = await this.$refs.shipmentEsim.validate().then((success) => {
          return success;
        });
        if (!validateHome) {
          this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
            icon: true,
            closeButton: "button",
          });
          return;
        }
      }
      if (this.currentItemInfo.shipment_type == "home" && !this.currentItem.IsUseESIM) {
        var validateHome = await this.$refs.shipmentTypeHome
            .validate()
            .then((success) => {
              return success;
            });
        if (!validateHome) {
          this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
            icon: true,
            closeButton: "button",
          });
          return;
        }
      }
      if (this.currentItemInfo.shipment_type == "itel" && !this.currentItem.IsUseESIM) {
        var validateItel = await this.$refs.shipmentTypeItel
            .validate()
            .then((success) => {
              return success;
            });
        if (!validateItel) {
          this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
            icon: true,
            closeButton: "button",
          });
          return;
        }
      }
      this.loading(true);
      this.isLoading = true;
      const data = {
        Id: this.currentItem.Id,
        IdCardCode: this.currentItem.IdCardCode,
        FullName: this.currentItem.FullName,
        ContactFullName: this.currentItem.ContactFullName,
        Phone: this.currentItem.Phone,
        ContactPhone: this.currentItem.ContactPhone,
        ContactEmail: this.currentItem.ContactEmail,
        Info: JSON.stringify(this.currentItemInfo),
        Address: this.currentItem.Address,
        Dob: this.formatDate(this.currentItem.Dob),
        IdCardCreatedDate: this.formatDate(this.currentItem.IdCardCreatedDate),
        IdCardPlace: this.currentItem.IdCardPlace,
        Gender: this.currentItem.Gender,
        Note: this.currentItem.notes ? this.currentItem.notes : "",
        paymentImage: this.currentItem?.PaymentImage ? this.currentItem.PaymentImage : "",
        shipFee: this.currentItem.ShippingFee,
      };

      useJwt
          .post("doi-sim/update-order", data)
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật thành công",
                icon: "AlertTriangleIcon",
                variant: "info",
              },
            });
            // this.loadItems();
            this.loading(false);
            this.isLoading = false;
            // this.$bvModal.hide("modal-view");
            // this.loadItems();
            this.requiredUpdate = false;
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error?.data?.result | "Cập nhật thất bại",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
            this.loading(false);
            this.isLoading = false;
          });
    },
    getGenderCode() {
      return this.optionGenders.find((el) => el.value == this.currentItem.Gender)?.code;
    },
    async fetchStores() {
      useJwt
          .post("getMasterData/B2C_Store", {
            columnFilters: {},
            sort: [],
            page: 1,
            pageSize: 1000,
          })
          .then((response) => {
            this.Stores = response.data.result.map((item) => {
              return {
                value: item.Id,
                text: item.Name,
              };
            });
          })
          .catch((err) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Có lỗi trong quá trình lấy dữ liệu!",
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    async fetchCities() {
      try {
        const res = await useJwt.post("getMasterData/GHTK_City", {
          columnFilters: {},
          sort: [],
          page: 1,
          pageSize: 1000,
        });

        this.Cities = res.data.result.map((item) => {
          return {
            value: item.Id,
            text: item.Name,
          };
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Có lỗi trong quá trình lấy dữ liệu!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
      }
    },
    async fetchDistricts(isCityChange = false, showLoading = true) {
      if (isCityChange) {
        this.currentItemInfo.DistrictId = 0;
        this.currentItemInfo.WardId = 0;
      }

      if (this.currentItemInfo.CityId > 0) {
        if (showLoading) {
          this.loading(true);
        }
        useJwt
            .post("getMasterData/GHTK_District", {
              columnFilters: {CityId: this.currentItemInfo.CityId},
              sort: [],
              page: 1,
              pageSize: 1000,
            })
            .then((response) => {
              this.Districts = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchWards(isDistrictChange = false, showLoading = true) {
      if (isDistrictChange) {
        this.currentItemInfo.WardId = 0;
      }

      if (this.currentItemInfo.DistrictId > 0) {
        if (showLoading) {
          this.loading(true);
        }

        useJwt
            .post("getMasterData/GHTK_Ward", {
              columnFilters: {DistrictId: this.currentItemInfo.DistrictId},
              sort: [],
              page: 1,
              pageSize: 1000,
              lang: this.$l,
            })
            .then((response) => {
              this.Wards = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    async fetchHamlets(isWardChange = false, showLoading = true) {
      if (isWardChange) {
        this.currentItemInfo.HamletId = 0;
      }

      if (this.currentItemInfo.WardId > 0) {
        if (showLoading) {
          this.loading(true);
        }
        this.getShipmentFee()
        useJwt
            .post("getMasterData/GHTK_Hamlet", {
              columnFilters: {WardId: this.currentItemInfo.WardId},
              sort: [],
              page: 1,
              pageSize: 1000,
              lang: this.$l,
            })
            .then((response) => {
              this.Hamlets = response.data.result.map((item) => {
                return {
                  value: item.Id,
                  text: item.Name,
                };
              });
              if (showLoading) {
                this.loading(false);
              }
            });
      }
    },
    compareStringLowerCase(srcObj, srcKey, targetObj, targetKey) {
      if (!srcObj && !targetObj) return true;

      if (!srcObj || !srcObj[srcKey]) {
        return true;
      }

      return (
          srcObj[srcKey]?.toString()?.toLowerCase() ==
          targetObj[targetKey]?.toString()?.toLowerCase()
      );
    },
  },
  data() {
    return {
      modalInputSeriOpen: false,
      firstTimeOpenModal: {
        currentCheck: false,
        currentInfoCheck: false,
      },
      requiredUpdate: false,
      qrType: 1,
      oprionsQRFile: [
        {text: "File", value: 1},
        {text: "QR", value: 2},
      ],
      optionsShipmentType: [
        {value: "home", text: "Giao hàng tận nơi"},
        {value: "itel", text: "Nhận tại phòng giao dịch iTel"},
      ],
      subscriberTypeOptions: [
        {
          value: "1",
          text: "Thuê bao chính chủ",
        },
        {
          value: "2",
          text: "Viết cam kết",
        },
      ],
      currentItemInfo: {},
      Cities: [],
      Districts: [],
      Wards: [],
      Hamlets: [],
      Stores: [],
      isEditPhoneEmail: false,
      searchString: "",
      isLoading: false,
      totalRecords: 0,
      rows: [],
      //dkttRows:[],
      editMode: false,
      totalItem: 0,
      searchQuery: "",
      searchTerm: "",
      currentItem: {},
      checkInfo: {},
      fields: [
        {
          field: "OrderCode",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Mã đơn hàng",
          width: "130px",
        },
        {
          field: "CreatedOn",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Ngày tạo",
          width: "110px",
        },
        {
          field: "Phone",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Số iTel",
          width: "100px",
        },
        {
          field: "FullName",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Họ tên CMND/CCCD",
        },
        {
          field: "IdCardCode",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "CMND/CCCD",
          width: "100px",
        },
        {
          field: "TotalPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Giá",
          tdClass: "text-right",
          width: "90px",
        },
        {
          field: "ContactFullName",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Tên người nhận",
        },
        {
          field: "ContactPhone",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "ĐT người nhận",
          tdClass: "text-center",
          width: "110px",
        },
        {
          field: "IsUseESIM",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "eSIM?",
          tdClass: "text-center",
          width: "50px",
        },
        {
          field: "PaymentChannel",
          filterOptions: {enabled: false, placeholder: "", trigger: "enter"},
          label: "HTTT",
        },
        {
          field: "StatusId",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: 0, text: "Chưa thanh toán"},
              {value: 1, text: "Đã thanh toán/Chờ xác nhận"},
              {value: 2, text: "Đã xác nhận/Chuyển vận đơn"},
              {value: 3, text: "Hoàn thành giao hàng"},
              {value: 11, text: " Chờ Callboot xác nhận đơn COD"},
              {value: 90, text: "Lỗi thanh toán"},
              {value: 91, text: "Trả hàng"},
              {value: 92, text: "Hủy đơn"},
              {value: 93, text: "Đơn hủy từ Baseus"},
            ],
          },
          width: "150px",
          label: "Tình trạng?",
        },
        {
          field: "ShipmentCode",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Vận chuyển",
        },
        {
          field: "CreateFrom",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Nguồn đơn",
        },
        {
          field: "CreateBy",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Người tạo",
        },
        {field: "action", label: "Thao tác", width: "80px"},
      ],
      optionsDoctype: [
        {value: "2", text: "CCCD"},
        {value: "1", text: "CMND"},
      ],
      optionGenders: [
        {value: "1", text: "Nam", code: "male"},
        {value: "2", text: "Nữ", code: "female"},
      ],
      statusList: [
        {id: 0, text: "Chưa thanh toán"},
        {id: 1, text: "Đã thanh toán/Chờ xác nhận"},
        {id: 2, text: "Đã xác nhận/Chuyển vận đơn"},
        {id: 3, text: "Hoàn thành giao hàng"},
        {id: 90, text: "Lỗi thanh toán"},
        {id: 91, text: "Trả hàng"},
      ],
      vnPayErrors: [
        {id: "00", text: "Giao dịch thành công"},
        {
          id: "07",
          text:
              "Trừ tiền thành công. Giao dịch bị nghi ngờ (liên quan tới lừa đảo, giao dịch bất thường).",
        },
        {
          id: "09",
          text:
              "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng chưa đăng ký dịch vụ InternetBanking tại ngân hàng.",
        },
        {
          id: "10",
          text:
              "Giao dịch không thành công do: Khách hàng xác thực thông tin thẻ/tài khoản không đúng quá 3 lần",
        },
        {
          id: "11",
          text:
              "Giao dịch không thành công do: Đã hết hạn chờ thanh toán. Xin quý khách vui lòng thực hiện lại giao dịch.",
        },
        {
          id: "12",
          text: "Giao dịch không thành công do: Thẻ/Tài khoản của khách hàng bị khóa.",
        },
        {
          id: "13",
          text:
              "Giao dịch không thành công do Quý khách nhập sai mật khẩu xác thực giao dịch (OTP). Xin quý khách vui lòng thực hiện lại giao dịch.",
        },
        {id: "24", text: "Giao dịch không thành công do: Khách hàng hủy giao dịch"},
        {
          id: "51",
          text:
              "Giao dịch không thành công do: Tài khoản của quý khách không đủ số dư để thực hiện giao dịch.",
        },
        {
          id: "65",
          text:
              "Giao dịch không thành công do: Tài khoản của Quý khách đã vượt quá hạn mức giao dịch trong ngày.",
        },
        {id: "75", text: "Ngân hàng thanh toán đang bảo trì."},
        {
          id: "79",
          text:
              "Giao dịch không thành công do: KH nhập sai mật khẩu thanh toán quá số lần quy định. Xin quý khách vui lòng thực hiện lại giao dịch",
        },
        {id: "99", text: "Lỗi thanh toán ngân hàng, quý khách vui lòng thử lại"},
      ],
      ghtkStatus: [
        {id: "-1", text: "Hủy đơn hàng"},
        {id: "1", text: "Chưa tiếp nhận"},
        {id: "2", text: "Đã tiếp nhận"},
        {id: "3", text: "Đã lấy hàng/Đã nhập kho"},
        {id: "4", text: "Đã điều phối giao hàng/Đang giao hàng"},
        {id: "5", text: "Đã giao hàng/Chưa đối soát"},
        {id: "6", text: "Đã đối soát"},
        {id: "7", text: "Không lấy được hàng"},
        {id: "8", text: "Hoãn lấy hàng"},
        {id: "9", text: "Không giao được hàng"},
        {id: "10", text: "Delay giao hàng"},
        {id: "11", text: "Đã đối soát công nợ trả hàng"},
        {id: "12", text: "Đã điều phối lấy hàng/Đang lấy hàng"},
        {id: "13", text: "Đơn hàng bồi hoàn"},
        {id: "20", text: "Đang trả hàng (COD cầm hàng đi trả)"},
        {id: "21", text: "Đã trả hàng (COD đã trả xong hàng)"},
        {id: "123", text: "Shipper báo đã lấy hàng"},
        {id: "127", text: "Shipper (nhân viên lấy/giao hàng) báo không lấy được hàng"},
        {id: "128", text: "Shipper báo delay lấy hàng"},
        {id: "45", text: "Shipper báo đã giao hàng"},
        {id: "49", text: "Shipper báo không giao được giao hàng"},
        {id: "410", text: "Shipper báo delay giao hàng"},
      ],
      URL_WEB_API: $ctx.API_URL.includes('dev') ? 'https://itel.dev' : 'https://itel.vn',
      serverParams: {
        columnFilters: {},
        sort: [{field: "CreatedOn", type: "desc"}],
        page: 1,
        pageSize: 50,
        lang: 1,
      },
      required,
      logs: [],
      ctx: $ctx,
      ImgPledgeDemo: ImgPledgeDemo,
      supportDevice: [],
      cardsOptions: [
        {
          id: 1,
          text: "10.000đ",
        },
        {
          id: 2,
          text: "20.000đ",
        },
        {
          id: 3,
          text: "50.000đ",
        },
        {
          id: 4,
          text: "100.000đ",
        },
        {
          id: 5,
          text: "200.000đ",
        },
        {
          id: 6,
          text: "300.000đ",
        },
        {
          id: 7,
          text: "500.000đ",
        },
        {
          id: 0,
          text: "Không có",
        }
      ],
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.image-container-list {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.modal-view-body {
  .form-control, .search-select .search-select-input span {
    font-size: 1rem;
    color: #000000;
  }
}

.modal-view-body {
  .form-group label:not(.form-control), .form-group .col-form-label {
    color: #000000;
    font-size: 1rem;
  }
}

.image-preview {
  z-index: 99999 !important;
}

.label-pledge-container {
  position: relative;
}

.btn-preview-image-container {
  position: absolute;
  width: 100px;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.4);
  border: none;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: default;
  gap: 8px;

  img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}

.image-container {
  position: relative;
}

.image-container:hover .btn-preview-image-container {
  display: flex;
}

.group-button-footer {
  display: flex;
  justify-content: end;
  gap: 10px;
}

.img-responsive {
  width: 100%;
}
</style>
<style>
.b2c-order .vgt-wrap {
  max-height: calc(100vh - 300px);
  overflow: auto;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.valid-txt small {
  color: green;
}

.isValid {
  border: 1px solid red;
}
</style>
